var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDoubleRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.488 6.524a.7.7 0 0 1 .99-.037l5.384 5a.7.7 0 0 1 0 1.026l-5.385 5a.7.7 0 1 1-.953-1.026L11.357 12 6.524 7.513a.7.7 0 0 1-.036-.99m5.615 0a.7.7 0 0 1 .99-.037l5.384 5a.7.7 0 0 1 0 1.026l-5.385 5a.7.7 0 1 1-.952-1.026L16.972 12 12.14 7.513a.7.7 0 0 1-.037-.99",
  clipRule: "evenodd"
})));
export default SvgChevronDoubleRight;